export default {
    "0": "IVR",
    "1": "DirectCall",
    "2": "Maskyoo",
}